import React, { memo, useMemo } from 'react';
import { FormattedNumber } from 'react-intl';

import { Card, Divider, Image, Spin, Typography } from 'antd';

import { ELITE_BADGES_URL, ELITE_DASHBOARD_URL } from 'settings';
import { Mask } from 'v2/components/Shared/ValuesVisibility';
import { useElite } from 'v2/hooks/useElite';

import { ELITE_BADGE_MINIMUM_GAINS } from './constants';
import EliteProgressBar from './EliteProgressBar';

const EliteCard = memo(() => {
  const { data, isPending } = useElite();

  const producerGains = useMemo(() => data?.gains_producer || 0, [data]);
  const affiliateGains = useMemo(() => data?.gains_affiliate || 0, [data]);
  const totalGains = useMemo(() => producerGains + affiliateGains, [affiliateGains, producerGains]);

  return (
    <Card className='flex h-full flex-col' classNames={{ body: 'flex flex-1 flex-col' }} title='Elite'>
      {isPending ? (
        <div className='flex min-h-55 flex-1 items-center justify-center'>
          <Spin />
        </div>
      ) : (
        <div className='flex flex-1 flex-col justify-between gap-4'>
          <div className='flex flex-col gap-4'>
            <div className='flex items-center justify-between'>
              <Typography.Text type='secondary'>Resumo de seus ganhos líquidos e faixa elite</Typography.Text>
              {producerGains >= ELITE_BADGE_MINIMUM_GAINS && data?.progress?.producer.current ? (
                <Image
                  width={50}
                  height={50}
                  preview={false}
                  src={`${ELITE_BADGES_URL}/${
                    data?.progress?.producer?.current?.has_plus
                      ? `${data.progress.producer.current.badge_elite}-plus.svg`
                      : `${data.progress.producer.current.badge_elite}.svg`
                  }`}
                  alt={`Badge ${data.progress.producer.current.name}`}
                />
              ) : null}
            </div>

            <EliteProgressBar producerGains={producerGains} />

            <div className='flex flex-col gap-2'>
              <div className='flex items-center justify-between gap-4'>
                <Typography.Text className='text-base' type='secondary'>
                  Ganhos como produtor/coprodutor:
                </Typography.Text>
                <Typography.Text className='text-base whitespace-nowrap'>
                  <Mask>
                    <FormattedNumber value={producerGains} format='BRL' />
                  </Mask>
                </Typography.Text>
              </div>
              <Divider className='m-0' />
              <div className='flex items-center justify-between gap-4'>
                <Typography.Text className='text-base' type='secondary'>
                  Ganhos como afiliado/coafiliado:
                </Typography.Text>
                <Typography.Text className='text-base whitespace-nowrap'>
                  <Mask>
                    <FormattedNumber value={affiliateGains} format='BRL' />
                  </Mask>
                </Typography.Text>
              </div>
              <Divider className='m-0' />
              <div className='flex items-center justify-between gap-4'>
                <Typography.Text className='text-base'>Total de ganhos:</Typography.Text>
                <Typography.Text className='text-base whitespace-nowrap'>
                  <Mask>
                    <FormattedNumber value={totalGains} format='BRL' />
                  </Mask>
                </Typography.Text>
              </div>
            </div>
          </div>

          <Typography.Link className='text-base' href={ELITE_DASHBOARD_URL} target='_blank' rel='noopener noreferrer'>
            Ver detalhes do programa elite
          </Typography.Link>
        </div>
      )}
    </Card>
  );
});

export default EliteCard;
